import axios from "axios";
import { ListPagination } from "../models/ListPagination";
import { ListQuery } from "../models/ListQuery";
import { Response } from "@/shared/models/Response";
import { List } from "../models/List";
import { ListHeader } from "../models/ListHeader";
import { Option } from "../models/Option";
import { ListCategory } from "@/shared/models/ListCategory";
import { ListChart } from "../models/ListChart";

export class ListService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/lists`;
  }

  async getListByFilters(query: ListQuery): Promise<Response<ListPagination>> {
    const serviceURL = `${this.baseUrl}/find-by-filters`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async getListByName(
    name: string,
    state?: boolean
  ): Promise<Response<ListHeader[]>> {
    const serviceURL = `${this.baseUrl}/query/by-name?name=${name}&state=${state}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getListById(id: string): Promise<Response<List>> {
    const serviceURL = `${this.baseUrl}/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async saveList(list: List): Promise<Response<string | void>> {
    const serviceURL = this.baseUrl;

    const response = await axios.post(serviceURL, list);
    return response.data;
  }

  async checkIfExistByName(name: string): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/exist-by-name`;

    const params = {
      params: {
        nameList: name
      }
    };

    const response = await axios.get(serviceURL, params);
    return response.data;
  }

  async updateStateListById(
    id: string,
    state: string
  ): Promise<Response<string | void>> {
    const serviceURL = `${this.baseUrl}/state/${id}/${state}`;
    const response = await axios.put(serviceURL);
    return response.data;
  }

  async updateList(id: string, list: List): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/${id}`;
    const response = await axios.put(serviceURL, list);
    return response.data;
  }

  async getListOptionsByName(name: string): Promise<Response<Option[]>> {
    const serviceURL = `${this.baseUrl}/query/options-by-name`;
    const response = await axios.get(serviceURL, { params: { name: name } });
    return response.data;
  }

  async getListDataByName(name: string): Promise<Response<List>> {
    const serviceURL = `${this.baseUrl}/query/data-by-name`;
    const response = await axios.get(serviceURL, { params: { name: name } });
    return response.data;
  }

  async getCategoriesList(): Promise<Response<ListCategory[] | void>> {
    const serviceURL = `${this.baseUrl}/query/categories`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getChart(query: ListQuery): Promise<Response<ListChart>> {
    const serviceURL = `${this.baseUrl}/charts`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async deleteListById(id: string): Promise<Response<string | void>> {
    const serviceURL = `${this.baseUrl}/${id}/`;
    const response = await axios.delete(serviceURL);
    return response.data;
  }
  async getAppointmentStatus(): Promise<Response<List>> {
    const serviceURL = `${this.baseUrl}/appointment/state`;
    const response = await axios.get(serviceURL);
    return response.data;
  }
  async getListCitiesByDepto(
    id: string,
    departmentCode: string
  ): Promise<Response<List>> {
    const serviceURL = `${this.baseUrl}/${id}/cities-by-department/${departmentCode}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }
  async getListDepartmentsByCountry(
    id: string,
    countryCode: string
  ): Promise<Response<List>> {
    const serviceURL = `${this.baseUrl}/${id}/departments-by-country/${countryCode}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }
}
